import React from 'react'
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import Footer from '../Footer/Footer';
import { VERSION } from '../../common/version';

    const phoneNumber = "+972548700200";
    const version = VERSION;
    function handleWhatsAppClick() {
      window.open(`https://wa.me/${phoneNumber}`, '_blank');
    }

function contact() {
  return (
    <div>
      <TopBaner></TopBaner>
      <SideBar></SideBar>
         <div  className='card contactDiv' style={{direction: "rtl"}}>
            <div style={{ 'textAlign': 'center'}}>
                <img src="pycBlueIogo.png" alt="logo-pych" style={{height :'100px'}}/>
            </div>
        <h2> צור קשר </h2>
        <h6>מוזמנים ליצור איתנו קשר עבור כל שאלה או בקשה בוואטסאפ שלנו או במייל </h6>
        <h6> אנחנו עושים את מירב המאמצים לענות לכולם בהקדם, תודה על הסבלנות ונסיעה טובה!        </h6>
        <h6> פאייכלה</h6>
        {/* <h6>+97229997715</h6> */}
        {/* <h6>(ניתן ללחוץ על האייקון לפתיחת צ'אט )</h6> */}
        <WhatsAppIcon  sx={{ color: '#25D366', mr: 1, my: 1 , fontSize: 45 ,  cursor: 'pointer', }} onClick={handleWhatsAppClick}></WhatsAppIcon>
    </div>
    <Footer></Footer>
    </div>
 
  )
}

export default contact